/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../../buttons/index.js";
import { colors } from "../../../../constants/colors.js";
import { useSpinnersContext } from "../../../../contexts/spinnersContext.js";

/* Styles */
import styles from "../styles.js"


const CloseFooter = props => {
  const { setShowModal, handleSaveModal, disableSubmit, submitText  } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const spinner = useSpinnersContext();

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col className={classes.cancelBtnCol}>
          <UCButton
            onClick={() => setShowModal(false)}
            type="primary"
            className={classes.cancelBtn}
            disabled={spinner.deleteCompanyActionSpinner}
            text={<FormattedMessage id="peopleGrid.deleteAction.cancel"/>}
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default CloseFooter;